import { createAppSubModule } from "../api/appModuleService";

export const useCreateSubModule = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createAppSubModule(data);
            if (successCallback) successCallback();
            return newRecord;
        } catch (error) {
            console.error("Failed to create app sub module:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};